import React from 'react';
import { Box, Grid, Paper, TextField, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  biometricKindLabel,
  calculateBiometricConfigTotal,
  formatBiometricCurrency,
  normalizeBiometricConfig,
} from 'Containers/Billing/biometricServiceConfig';

function BiometricServiceConfigPanel({ config, onChange, disabled = false }) {
  const normalized = normalizeBiometricConfig(config);
  const total = calculateBiometricConfigTotal(normalized);

  const updateField = (key, value) => {
    if (disabled || typeof onChange !== 'function') return;
    onChange({
      ...normalized,
      [key]: value,
    });
  };

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="subtitle2" fontWeight={700} gutterBottom>
        {biometricKindLabel(normalized.kind)}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Enter number of devices, fee, and renewable fee. Total is devices × fee.
      </Typography>
      <Grid container spacing={1.5}>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Number of devices"
            type="number"
            size="small"
            fullWidth
            required
            value={normalized.deviceCount}
            onChange={(e) => updateField('deviceCount', e.target.value)}
            disabled={disabled}
            inputProps={{ min: 0, step: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Fee (₹)"
            type="number"
            size="small"
            fullWidth
            required
            value={normalized.fee}
            onChange={(e) => updateField('fee', e.target.value)}
            disabled={disabled}
            inputProps={{ min: 0, step: 0.01 }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            label="Renewable fee (₹)"
            type="number"
            size="small"
            fullWidth
            value={normalized.renewalFee}
            onChange={(e) => updateField('renewalFee', e.target.value)}
            disabled={disabled}
            inputProps={{ min: 0, step: 0.01 }}
          />
        </Grid>
      </Grid>
      <Paper
        variant="outlined"
        sx={{
          mt: 2,
          p: 1.5,
          borderRadius: 2,
          bgcolor: (theme) => alpha(theme.palette.success.main, 0.08),
          borderColor: 'success.light',
        }}
      >
        <Typography variant="body2" color="text.secondary">
          Line total (devices × fee):{' '}
          <Box component="span" fontWeight={700} color="text.primary">
            {formatBiometricCurrency(total)}
          </Box>
          {normalized.renewalFee !== '' && normalized.renewalFee != null ? (
            <>
              {' · '}Renewable fee:{' '}
              <Box component="span" fontWeight={600} color="text.primary">
                {formatBiometricCurrency(normalized.renewalFee)}
              </Box>
            </>
          ) : null}
        </Typography>
      </Paper>
    </Box>
  );
}

export default BiometricServiceConfigPanel;
